import React from 'react';
import { Users, ListTree, ArrowDownRight, ArrowUpRight, RefreshCcw, Activity } from 'lucide-react';
import { LineChart, Line, ResponsiveContainer } from 'recharts';
const generateSparklineData = (trend: 'up' | 'down' | 'stable') => {
  return Array.from({
    length: 10
  }).map((_, i) => ({
    value: trend === 'up' ? 10 + i * 2 + Math.random() * 5 : trend === 'down' ? 30 - i * 2 + Math.random() * 5 : 20 + Math.random() * 10
  }));
};
const kpis = [{
  title: 'Total Leads in Routing',
  value: '142,894',
  delta: '+2.4%',
  trend: 'up',
  icon: Users,
  color: 'text-indigo-400',
  bgColor: 'bg-indigo-400/10',
  sparklineColor: '#818cf8',
  data: generateSparklineData('up')
}, {
  title: 'Active Dial Lists',
  value: '24',
  delta: '0%',
  trend: 'stable',
  icon: ListTree,
  color: 'text-sky-400',
  bgColor: 'bg-sky-400/10',
  sparklineColor: '#38bdf8',
  data: generateSparklineData('stable')
}, {
  title: 'Leads Added Today',
  value: '12,405',
  delta: '+14.2%',
  trend: 'up',
  icon: ArrowDownRight,
  color: 'text-emerald-400',
  bgColor: 'bg-emerald-400/10',
  sparklineColor: '#34d399',
  data: generateSparklineData('up')
}, {
  title: 'Leads Removed Today',
  value: '8,192',
  delta: '-3.1%',
  trend: 'down',
  icon: ArrowUpRight,
  color: 'text-amber-400',
  bgColor: 'bg-amber-400/10',
  sparklineColor: '#fbbf24',
  data: generateSparklineData('down')
}, {
  title: 'SF vs Five9 Variance',
  value: '0.02%',
  delta: '-0.01%',
  trend: 'down',
  icon: RefreshCcw,
  color: 'text-emerald-400',
  bgColor: 'bg-emerald-400/10',
  sparklineColor: '#34d399',
  data: generateSparklineData('down')
}, {
  title: 'Queue Health Score',
  value: '98.4',
  delta: '+0.2',
  trend: 'up',
  icon: Activity,
  color: 'text-emerald-400',
  bgColor: 'bg-emerald-400/10',
  sparklineColor: '#34d399',
  data: generateSparklineData('up')
}];
export function KPIRow() {
  return <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4 mb-6" data-id="element-204">
      {kpis.map((kpi, index) => <div key={index} className="bg-slate-900/80 border border-slate-800/60 rounded-xl p-4 shadow-sm relative overflow-hidden group hover:border-slate-700 transition-colors" data-id="element-205">
          <div className="flex justify-between items-start mb-2" data-id="element-206">
            <div className="flex items-center gap-2" data-id="element-207">
              <div className={`p-1.5 rounded-md ${kpi.bgColor}`} data-id="element-208">
                <kpi.icon className={`w-4 h-4 ${kpi.color}`} data-id="element-209" />
              </div>
              <span className="text-xs font-medium text-slate-400" data-id="element-210">
                {kpi.title}
              </span>
            </div>
          </div>

          <div className="mt-3 flex items-baseline gap-2" data-id="element-211">
            <span className="text-2xl font-bold text-white tabular-nums tracking-tight" data-id="element-212">
              {kpi.value}
            </span>
            <span className={`text-xs font-medium tabular-nums ${kpi.trend === 'up' ? 'text-emerald-400' : kpi.trend === 'down' ? 'text-rose-400' : 'text-slate-400'}`} data-id="element-213">
              {kpi.trend === 'up' ? '▲' : kpi.trend === 'down' ? '▼' : '−'}{' '}
              {kpi.delta}
            </span>
          </div>

          <div className="h-8 mt-2 -mx-1 opacity-60 group-hover:opacity-100 transition-opacity" data-id="element-214">
            <ResponsiveContainer width="100%" height="100%" data-id="element-215">
              <LineChart data={kpi.data} data-id="element-216">
                <Line type="monotone" dataKey="value" stroke={kpi.sparklineColor} strokeWidth={2} dot={false} isAnimationActive={false} data-id="element-217" />
              </LineChart>
            </ResponsiveContainer>
          </div>

          {/* Subtle gradient glow on hover */}
          <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-transparent to-white/[0.02] opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" data-id="element-218"></div>
        </div>)}
    </div>;
}